import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getWebhookList } from '../clients/gateway.api';

export const webhooks = createQueryKeys('webhooks', {
    list: (groupId: string) => ({
        queryKey: [groupId],
        queryFn: () => getWebhookList(groupId),
    }),
});
